export default __webpack_public_path__ + "static/media/grey_dolphin_icon_for.4c7a80ea.svg";